
export function Wordmark({
  height = 28,
  alt = 'Cheddule',
  className,
}: {
  height?: number;
  alt?: string;
  className?: string;
}) {
  const width = Math.round((height * 1440) / 300);
  return (
    <img
      src="/wordmark.svg"
      alt={alt}
      width={width}
      height={height}
      className={className}
      draggable={false}
    />
  );
}

export function Brandmark({
  size = 32,
  alt = 'Cheddule',
  className,
}: {
  size?: number;
  alt?: string;
  className?: string;
}) {
  return (
    <img
      src="/brandmark.svg"
      alt={alt}
      width={size}
      height={size}
      className={className}
      draggable={false}
    />
  );
}
